"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEnterPhoneNumberShow = trackEnterPhoneNumberShow;
var _analytics = require("@cian/analytics");
function trackEnterPhoneNumberShow() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Open',
    label: 'add_phone_number'
  });
}